import React, { useState } from "react";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { Bars } from "react-loader-spinner";
import axiosInstance from "../../Shared/axiosInstance.js";

export default function CreateCustomer() {
  const [errorMsg, setErrorMsg] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: { name: "", phone: "", details: "" },
    validate: (values) => {
      const errors = {};
      setErrorMsg(null);

      if (!values.name.trim()) errors.name = "الاسم مطلوب";

      if (!values.phone.trim()) {
        errors.phone = "رقم الهاتف مطلوب";
      } else if (!/^[0-9+\-\s()]+$/.test(values.phone)) {
        errors.phone = "يمكن أن يحتوي رقم الهاتف على أرقام و + - () فقط";
      }

      if (!values.details.trim()) errors.details = "التفاصيل مطلوبة";

      return errors;
    },
    onSubmit: async (values) => {
      setIsLoading(true);
      try {
        const { data } = await axiosInstance.post("/Customer", values);

        if (data?.status === 200) {
          await Swal.fire({
            title: "تم الإضافة!",
            text: data.message || "تم إضافة العميل بنجاح",
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
          });

          navigate("/customers");
        }
      } catch (error) {
        console.error("حدث خطأ أثناء إضافة العميل:", error);
        setErrorMsg(error?.response?.data?.message || "حدث خطأ ما");
      } finally {
        setIsLoading(false);
      }
    }
  });

  return (
    <div
      style={{ background: "#f8fafc", minHeight: "100vh", paddingBottom: "40px", direction: "rtl" }}
    >
      <div className="container py-5" style={{ maxWidth: "700px" }}>
        <h2 style={{ color: "#06b6d4", fontWeight: "700", fontSize: "28px", marginBottom: "10px" }}>
          <i className="bi bi-person-plus me-2"></i>إضافة عميل جديد
        </h2>
        <small style={{ color: "#64748b", fontSize: "14px", marginBottom: "20px", display: "block" }}>
          أدخل بيانات العميل
        </small>

        {errorMsg && (
          <div style={{
            background: "#fee2e2",
            border: "1px solid #fecaca",
            color: "#991b1b",
            padding: "12px 16px",
            borderRadius: "8px",
            marginBottom: "20px",
            fontSize: "14px",
            fontWeight: "600",
          }}>
            <i className="bi bi-exclamation-triangle me-2"></i>
            {errorMsg}
          </div>
        )}

        <div style={cardStyle}>
          <form onSubmit={formik.handleSubmit}>
            {/* الاسم */}
            <div className="mb-4">
              <label style={labelStyle}><i className="bi bi-person me-2"></i>اسم العميل *</label>
              <input
                type="text"
                name="name"
                placeholder="أدخل اسم العميل"
                value={formik.values.name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                style={{
                  ...inputStyle,
                  borderColor: formik.touched.name && formik.errors.name ? "#dc2626" : "#cbd5e1"
                }}
              />
              {formik.errors.name && formik.touched.name && (
                <div style={errorStyle}><i className="bi bi-exclamation-circle me-1"></i>{formik.errors.name}</div>
              )}
            </div>

            {/* الهاتف */}
            <div className="mb-4">
              <label style={labelStyle}><i className="bi bi-telephone me-2"></i>رقم الهاتف *</label>
              <input
                type="text"
                name="phone"
                placeholder="أدخل رقم الهاتف"
                value={formik.values.phone}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                style={{
                  ...inputStyle,
                  borderColor: formik.touched.phone && formik.errors.phone ? "#dc2626" : "#cbd5e1"
                }}
              />
              {formik.errors.phone && formik.touched.phone && (
                <div style={errorStyle}><i className="bi bi-exclamation-circle me-1"></i>{formik.errors.phone}</div>
              )}
            </div>

            {/* التفاصيل */}
            <div className="mb-4">
              <label style={labelStyle}><i className="bi bi-card-text me-2"></i>التفاصيل *</label>
              <textarea
                name="details"
                placeholder="أدخل تفاصيل العميل"
                rows="5"
                value={formik.values.details}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                style={{
                  ...inputStyle,
                  minHeight: "120px",
                  borderColor: formik.touched.details && formik.errors.details ? "#dc2626" : "#cbd5e1"
                }}
              />
              {formik.errors.details && formik.touched.details && (
                <div style={errorStyle}><i className="bi bi-exclamation-circle me-1"></i>{formik.errors.details}</div>
              )}
            </div>

            {/* الأزرار */}
            <div className="d-flex gap-3">
              <button
                type="submit"
                disabled={!(formik.dirty && formik.isValid) || isLoading}
                style={{
                  flex: 1,
                  background: formik.dirty && formik.isValid && !isLoading ? "linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)" : "#94a3b8",
                  color: "#fff",
                  padding: "16px",
                  borderRadius: "8px",
                  border: "none",
                  fontWeight: "700",
                  fontSize: "18px",
                  cursor: formik.dirty && formik.isValid && !isLoading ? "pointer" : "not-allowed",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
              >
                {isLoading ? (
                  <>
                    <Bars height="25" width="25" color="#fff" ariaLabel="loading" />
                    <span>جارٍ الإضافة...</span>
                  </>
                ) : (
                  <>
                    <i className="bi bi-check-circle"></i>
                    <span>إضافة العميل</span>
                  </>
                )}
              </button>

              <button
                type="button"
                onClick={() => navigate("/customers")}
                style={{
                  flex: 1,
                  background: "#fff",
                  color: "#475569",
                  padding: "16px",
                  borderRadius: "8px",
                  border: "2px solid #cbd5e1",
                  fontWeight: "700",
                  fontSize: "18px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
              >
                <i className="bi bi-x-circle"></i>
                <span>إلغاء</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

// Styles
const cardStyle = {
  background: "#fff",
  border: "1px solid #e2e8f0",
  borderRadius: "12px",
  padding: "32px",
  marginBottom: "20px",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
};

const labelStyle = {
  color: "#475569",
  fontSize: "15px",
  fontWeight: "600",
  marginBottom: "8px",
  display: "block",
};

const inputStyle = {
  width: "100%",
  padding: "12px 16px",
  border: "2px solid #cbd5e1",
  borderRadius: "8px",
  fontSize: "15px",
  color: "#1e293b",
  outline: "none",
  transition: "all 0.2s",
  fontWeight: "500",
};

const errorStyle = {
  color: "#dc2626",
  fontSize: "13px",
  marginTop: "6px",
  fontWeight: "600",
};
